import {FILTER_NAMES} from '../base.js'
import {LISTING_SECTION_IDS} from './listingSections.js'

export const LISTING_SECTIONS_WITH_SEARCH_SAVE = [
  LISTING_SECTION_IDS.ALL_VEHICLES,
  LISTING_SECTION_IDS.KM0_VEHICLES,
  LISTING_SECTION_IDS.NEW_VEHICLES,
  LISTING_SECTION_IDS.NO_LICENSE_VEHICLES,
  LISTING_SECTION_IDS.RENTING_VEHICLES,
  LISTING_SECTION_IDS.SECOND_HAND_VEHICLES,
  LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES
]

export const NOT_AVAILABLE_FILTERS = [
  FILTER_NAMES.EXCLUDED_VEHICLES,
  FILTER_NAMES.FINANCING_ENTRY,
  FILTER_NAMES.FINANCING_TERMS,
  FILTER_NAMES.HAS_ONLINE_FINANCING,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTER_NAMES.HAS_RESERVATION,
  FILTER_NAMES.HAS_STOCK,
  FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
  FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE
]

export const MAX_ALERTS_LIMIT_REACHED = 40
export const MAX_ALERTS_LIMIT_REACHED_ERROR_CODE = 'create_alert_exception_too_many_saved_searches'
